import styled from "styled-components";
import { darkModeColors } from "../../consts";
import { Paragraph2, WrapperContainer } from "../../components";

export const PasswordValidationWrapper = styled(WrapperContainer)`
  background: ${darkModeColors.ISABELLINE_DARK_RAISIN};
  border-radius: 8px;

  ${Paragraph2}, li {
    font-size: 12px;
    line-height: 18px;

    color: ${darkModeColors.RAISIN_100_RAISIN_40};
  }

  ul {
    list-style: disc;
    margin-left: 20px;
  }
`;
